import { useCallback, useState } from 'react';

import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';

const DEFAULT_ACL_QUERY_MODE = ACLQueryModeTypes.MODE_COLLABORATOR.key;

type UseLocalAccessLevel = {
  isOwner: boolean;
  aclQueryMode: string;
  onChangeAccessLevel: (level: string) => void;
};

function useLocalAccessLevel(): UseLocalAccessLevel {
  const [aclQueryMode, setAclQueryMode] = useState(DEFAULT_ACL_QUERY_MODE);

  const onChangeAccessLevel = useCallback((level: string) => setAclQueryMode(level), []);

  const isOwner = aclQueryMode === ACLQueryModeTypes.MODE_OWNER.key;

  return { aclQueryMode, onChangeAccessLevel, isOwner };
}

export { useLocalAccessLevel };
